import { useFormContext } from 'react-hook-form'
import { AppointmentPayment, BookAppointmentForm } from './BookAppointmentTypes'

const paymentOptions: Array<{ label: string; value: AppointmentPayment }> = [
  { label: 'Pay now', value: 'pay_now' },
  { label: 'Pay at the hospital', value: 'pay_at_hospital' }
]

export const BookAppointmentStepPayment = () => {
  const { setValue, watch } = useFormContext<BookAppointmentForm>()
  const selectedPayment = watch('payment_option')

  return (
    <div className="flex flex-col gap-3">
      {paymentOptions.map(option => {
        const isActive = selectedPayment === option.value

        return (
          <button
            className={`flex h-12 items-center justify-between rounded-lg border border-[#ECECEC] bg-white px-4 text-sm text-[#2A2A2A] ${option.value === 'pay_now' ? 'cursor-not-allowed' : ''}`}
            disabled={option.value === 'pay_now'}
            key={option.value}
            onClick={() => setValue('payment_option', option.value, { shouldDirty: true, shouldValidate: true })}
            type="button"
          >
            <span>{option.label}</span>
            <span
              className={`flex h-5 w-5 items-center justify-center rounded-full border ${
                isActive ? 'border-[#A79A46]' : 'border-[#DADADA]'
              }`}
            >
              <span className={`h-2.5 w-2.5 rounded-full ${isActive ? 'bg-[#A79A46]' : 'bg-transparent'}`} />
            </span>
          </button>
        )
      })}
    </div>
  )
}
